import React from 'react';
import { Modal, Spin } from 'antd';

const LoadingModal = ({ open, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    centered
    closable={false}
    maskClosable={false}
  >
    <div style={{ textAlign: 'center' }}>
      <Spin size="large" />
      <p style={{ marginTop: 10 }}>Cargando...</p>
    </div>
  </Modal>
);

export default LoadingModal;
